import type { JSX } from 'react'

import { AuthLayout, AuthLayoutWrapper } from "/app/libraries/arcana/src/blocks/AuthLayout/index.ts"
import { BrandContainerDefault } from "/app/libraries/arcana/src/blocks/BrandContainer/Templates/index.ts"
import { Spinner } from "/app/libraries/arcana/src/atoms/Spinner/index.ts"

import { useUnit } from 'effector-react'
import { useEffect } from 'react'
import { model as logoModel } from '~/features/logo'
import { Loader } from '~/shared/ui/components/Loader'
import { authLayoutModel } from '~/widgets/auth'
import { ThemeProvider } from './ThemeProvider'

import classes from './style.module.css'

Bootstrap.displayName = 'Bootstrap'
export function Bootstrap(): JSX.Element {
  const { logoUrl, logoHeight, backgroundUrl, backgroundLoaded } = useUnit({
    logoUrl: logoModel.$logoUrl,
    logoHeight: logoModel.$logoHeight,
    backgroundUrl: authLayoutModel.$authBackgroundUrl,
    backgroundLoaded: authLayoutModel.$backgroundLoaded,
  })

  useEffect(() => {
    authLayoutModel.loadBackground()
  }, [])

  return (
    <ThemeProvider>
      <Loader />
      <AuthLayoutWrapper>
        <AuthLayout
          posterUrl={backgroundUrl}
          backgroundOpacity={backgroundLoaded ? 1 : 0}
          backgroundOpacityTransitionDuration={1}
          overlayEnabled={true}
          overlayWidth={60}
          overlayHeight={50}
          paddingTop='110px'
        >
          <a href='/'>
            <BrandContainerDefault
              logoUrl={logoUrl}
              logoHeight={logoHeight || '60px'}
              scaleLogo={true}
            />
          </a>
          <div className={classes.wrapper}>
            <Spinner />
          </div>
        </AuthLayout>
      </AuthLayoutWrapper>
    </ThemeProvider>
  )
}
